import { Box, Stack } from "@mui/material";
import { useMemo, useRef } from "react";
import RenderOption from "./renderOption";
import OptionsPopper from "./optionsPopper";
import KeyboardArrowRightRounded from "@mui/icons-material/KeyboardArrowRightRounded";
import KeyboardArrowDownRounded from "@mui/icons-material/KeyboardArrowDownRounded";
import { optionSx } from "./styles";
import FadedScrollBox from "./fadedScrollBox";

export default function CustomInnerAutocomplete({
  value,
  onSelect,
  outerOption,
  innerOpen,
  setInnerOpen,
  active,
  innerListRef,
  innerActive,
  setInnerActive,
  innerOptions,
  setActive,
  index,
  inputFieldRef,
  dataIdx,
}) {
  const anchorRef = useRef(null);

  function onCloseInner() {
    if (inputFieldRef.current === document.activeElement) return;
    setInnerOpen(-1);
    setInnerActive(null);
  }

  const open = useMemo(() => {
    return innerOpen === index;
  }, [innerOpen, index]);

  return (
    <Box>
      <Box
        data-idx={dataIdx}
        onClick={() => {
          setActive(index);
          setInnerOpen(open ? -1 : index);
          setInnerActive(0);
          queueMicrotask(() => inputFieldRef.current.focus());
        }}
        ref={anchorRef}
        sx={optionSx(active)}
      >
        <Stack direction="row">
          {open ? (
            <KeyboardArrowDownRounded fontSize="small" sx={{ opacity: 0.8 }} />
          ) : (
            <KeyboardArrowRightRounded fontSize="small" sx={{ opacity: 0.8 }} />
          )}
          {outerOption.label} = {value}
        </Stack>
      </Box>
      <OptionsPopper open={open} onClose={onCloseInner} anchorRef={anchorRef}>
        <FadedScrollBox
          listRef={innerListRef}
          onMouseDown={(e) => e.preventDefault()}
        >
          {innerOptions.length > 0 ? (
            innerOptions.map((option, i) => (
              <RenderOption
                key={i}
                active={i === innerActive}
                innerDataIndex={i}
                onMouseEnter={() => setInnerActive(i)}
                outerOption={outerOption}
                option={option}
                onSelect={onSelect}
                setActive={setActive}
                index={index}
                inputFieldRef={inputFieldRef}
              ></RenderOption>
            ))
          ) : (
            <RenderOption
              key={0}
              outerOption={outerOption}
              option={null}
              onSelect={onSelect}
              inputFieldRef={inputFieldRef}
            ></RenderOption>
          )}
        </FadedScrollBox>
      </OptionsPopper>
    </Box>
  );
}
